module.exports = __webpack_public_path__ + "static/media/edit_pink.26bdb73e.svg";